import React, { Component } from 'react';

import { QueryComponent } from '../../../GraphQL';
import { getMyMockExamList } from '../../../GraphQL/query/ScoreForm.query';
import { MASTER_EXAM_STATUS } from '../../../GraphQL/query/MockExam.query';
import LinkMockExamPanelView from './LinkMockExamPanel.view';

const filterExamCards = examCards =>
  examCards.filter(card => card.exam.status === MASTER_EXAM_STATUS.GRADE_READY);

const filterExamRounds = examRounds => {
  return examRounds.filter(round =>
    round.examCards.find(card => card.exam.status === MASTER_EXAM_STATUS.GRADE_READY)
  );
};

class LinkMockExamPanel extends Component {
  handleSubmit = (round, examRounds) => {
    const examCards = examRounds[round].examCards;
    const filteredExamCards = filterExamCards(examCards);
    const examCardIds = filteredExamCards.map(card => {
      return { examCardId: card.id, subjectCode: card.subjectCode, examId: card.examId };
    });
    this.props.onSubmit(examCardIds);
  };

  render() {
    return (
      <QueryComponent query={getMyMockExamList}>
        {data => {
          const { myMockExamList } = data || {};
          const { examRounds } = myMockExamList || {};
          const filteredExamRounds = filterExamRounds(examRounds);
          const dropdownOptions =
            filteredExamRounds.length > 0
              ? filteredExamRounds.map((round, index) => {
                  return { key: round.title, text: round.title, value: index.toString() };
                })
              : [];

          return (
            <LinkMockExamPanelView
              onSubmit={round => this.handleSubmit(round, examRounds)}
              dropdownOptions={dropdownOptions}
            />
          );
        }}
      </QueryComponent>
    );
  }
}

export default LinkMockExamPanel;
